/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

const COMPANY_SCOPE_QUERY_KEYS = ['companyId', 'selectedCompanyId'] as const;

export function readCompanyScopeCandidateFromSearch(search: string): string | null {
  try {
    const params = new URLSearchParams(search || '');
    const raw = COMPANY_SCOPE_QUERY_KEYS
      .map((key) => params.get(key))
      .find((value) => value !== null);
    const value = String(raw ?? '').trim();
    return /^[1-9]\d*$/.test(value) ? value : null;
  } catch {
    return null;
  }
}

export function stripCompanyScopeFromRelativeUrl(
  pathname: string,
  search: string,
  hash: string,
): string {
  const params = new URLSearchParams(search || '');
  for (const key of COMPANY_SCOPE_QUERY_KEYS) {
    params.delete(key);
  }
  const query = params.toString();
  return `${pathname || '/'}${query ? `?${query}` : ''}${hash || ''}`;
}

/**
 * Launch query'si yalnız doğrulanacak adaydır. Aday belleğe alındıktan hemen
 * sonra tarayıcı geçmişindeki mevcut kayıttan temizlenir.
 */
export function stripCompanyScopeFromBrowserUrl(): void {
  if (typeof window === 'undefined') return;
  try {
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const next = stripCompanyScopeFromRelativeUrl(
      window.location.pathname,
      window.location.search,
      window.location.hash,
    );
    if (next !== current) {
      window.history.replaceState(window.history.state, '', next);
    }
  } catch {
    /* URL temizliği firma doğrulama akışını durdurmamalı. */
  }
}
